export class TripType {

    private name: string;
    private regimeType: string;
    private letterRetirement: string;

    public getName(): string {
        return this.name;
    }

    public setName(name: string): void {
        this.name = name;
    }

    public getRegimeType(): string {
        return this.regimeType;
    }

    public setRegimeType(regimeType: string): void {
        this.regimeType = regimeType;
    }

    public getLetterRetirement(): string {
        return this.letterRetirement;
    }

    public setLetterRetirement(letterRetirement: string): void {
        this.letterRetirement = letterRetirement;
    }

    public deserialize(input: any) {
        Object.assign(this, input);

        for (const key in input) {
            if (Object.prototype.hasOwnProperty.call(input, key)) {
                if (this['set' + key.charAt(0).toUpperCase() + key.slice(1)]) {
                    this['set' + key.charAt(0).toUpperCase() + key.slice(1)](input[key]);
                }
            }
        }

        return this;
    }

}
